module.exports = __webpack_public_path__ + "img/women-wig-review-1.7114d0a4.jpg";